import { Machine } from '@modules/test-development/components/run-results/machine-config/machine/machine';
import { TestDevice } from '@modules/test-development/models/test-device.model';
import React from 'react';
import { Icon } from '@testsigma/atoms';
import { TestPlanLabType } from '@modules/test-development/enums/test-plan-lab-type.enum';
import classNames from 'classnames';

interface TestDeviceIconGroupProps {
  environments: TestDevice[];
  variant?: 'machines' | 'labs';
  testPlanId?: string | number;
  labTypeVariant?: 'detail' | 'concise';
  hideLaptypeIcon?: boolean;
}

const TestDeviceIconGroup: React.FC<TestDeviceIconGroupProps> = ({
  environments,
  variant = 'machines',
  testPlanId,
  labTypeVariant,
  hideLaptypeIcon,
}) => {
  return (
    <div
      className={classNames(
        'flex flex-row flex-wrap gap-5 !text-secondary-500',
        {
          'gap-5': variant == 'machines',
          'gap-1': variant == 'labs',
        },
      )}>
      {environments.map((environment: TestDevice, idx) => (
        <Machine
          key={idx}
          className={variant === 'machines' ? '!gap-x-1.5' : '!gap-x-0'}
          testDevice={environment}
          showOsType={variant === 'machines'}
          showDeviceType={variant === 'machines'}
          testPlanId={testPlanId}
          variant={labTypeVariant}
          hideLaptypeIcon={hideLaptypeIcon}
        />
      ))}
    </div>
  );
};

export default TestDeviceIconGroup;
